import { render, staticRenderFns } from "./inspectionTaskDetail.vue?vue&type=template&id=148f9599&scoped=true&"
import script from "./inspectionTaskDetail.vue?vue&type=script&lang=js&"
export * from "./inspectionTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectionTaskDetail.vue?vue&type=style&index=0&id=148f9599&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f9599",
  null
  
)

export default component.exports